import { useState, useEffect } from "react";
import Input from "../../design/Input";


function ContinerData({data, setClose, onDClick}) {
    const [dataFilter, setDataFilter] = useState({});
    const [inputFilter, setInputFilter] = useState("");

    useEffect(() => {
        setDataFilter(data);
    }, [data])

    const filteredData = (value) => {
        if (value) {
            const dataToUpdate = Object.keys(data).filter(key => key.startsWith(value))
            .reduce((obj, key) => {
                obj[key] = data[key];
                return obj;
            }, {})

            setDataFilter(dataToUpdate);
        } else {
            setDataFilter(data);
        }
        setInputFilter(value);
    }

    return (
        <div className={"aufaSumDataContinerData"}>
            <p className={"aufaSumDataBack"} onClick={() => setClose()}>
                <span>חזרה</span>
            </p>

            <div className={"aufaSumDataInput"}>

                <Input
                textView={"חיפוש"}
                value={inputFilter}
                onChange={filteredData}
                />

            </div>

            {
                Object.keys(dataFilter).length > 0 && Object.keys(dataFilter).map((keyData, key) => (

                    <div key={key} onDoubleClick={() => onDClick(keyData)}>
                        <p> {keyData} </p>

                        <div>
                            <p key={key + 1 * 1}> סה"כ מקומות - <span> {dataFilter[keyData]['places']} </span></p>
                            <p key={key + 1 * 2}> סה"כ נקנו - <span> {dataFilter[keyData]['buy']} </span></p>
                            <p key={key + 1 * 3}> סה"כ שמורים - <span> {dataFilter[keyData]['save']} </span></p>
                            <p key={key + 1 * 4}>סה"כ - <span>{dataFilter[keyData]['places'] - dataFilter[keyData]['buy'] - dataFilter[keyData]['save']}</span></p>
                        </div>
                    </div>
                ))
            }
        </div>
    )
}


export default ContinerData;